const initialState = {
    expandRouteMenu: false
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_ROUTE_MENU':
            return {
                ...state,
                expandRouteMenu: action.toggleFlag
            };
        default:
            return state;
    }
};